// extracted by mini-css-extract-plugin
export var calendarView = "_jf-0";